/**
 * Polyfill for `Map.groupBy` which is not supported in older browsers
 * (Safari < 17.2, older iOS WebKit). Remove once browser support is sufficient.
 * @see https://caniuse.com/mdn-javascript_builtins_map_groupby
 */
export function mapGroupBy<K, T>(items: T[], keyFn: (item: T) => K): Map<K, T[]> {
    const map = new Map<K, T[]>();
    for (const item of items) {
        const key = keyFn(item);
        const group = map.get(key);
        if (group) {
            group.push(item);
        } else {
            map.set(key, [item]);
        }
    }
    return map;
}
